export default __webpack_public_path__ + "static/media/complete.d5fba8a9.svg";